<template lang="html">
    <section class="list-shades row">
        <loader :position="'fixed'" :spinLeft="'60%'" :loading="isLoader"></loader>
        <div
            class="col-lg-3 col-md-3 col-xs-6 list-shades-bloc"
            v-for="(item, key) in dataShades"
            :key="key"
            :class="{ noBorder: Number((key + 1) / 4) % 1 === 0 }"
        >
            <figure class="list-shades-figure">
                <router-link tag="a" :to="'/product/' + item.component.id + '?refere=shades'">
                    <img
                        src="../../../static/img/no_image.jpg"
                        class="grab img-fluid ff-medium svgMeuble center"
                        v-if="!item.component.figures.small"
                    />
                    <img :src="getImgPath(item.component.figures.small)" v-if="item.component.figures.small" />
                </router-link>
            </figure>
            <div class="bgColor" :style="item.properties.colors ? { 'background-color': item.properties.colors.color.value } : ''">
                <i v-if="!item.properties.colors" class="far fa-empty-set"></i>
            </div>
            <div class="detailShade">
                <h3 class="titleShade">{{ getTranslate(item.component.terms.name) }}</h3>
                <p class="refShade">
                    <span v-if="item.properties.number">{{ item.properties.number.numb1.value }}</span>
                    <span>- {{ item.terms.name ? getTranslate(item.terms.name) : item.name }}</span>
                    <span class="block">({{ item.properties.reference.client_ref1.value }})</span>
                </p>
            </div>
        </div>
    </section>
</template>

<script lang="js">
    import Globals from "../globals.js";
    import loader from "../loader/loader";
  export default  {
    name: 'list-shades',
    props: ["dataShades", "isLoader"],
    components: {
      loader
    },
    data() {
      return {
      }
    },
    methods: {
        getImgPath(imgPath) {
            return Globals.getBaseUrl() + imgPath;
        }
    }
}
</script>

<style scoped lang="scss">
.list-shades {
    width: 100%;
    &-bloc {
        /*border-right: 1px solid #ccc;*/
        text-align: center;
        margin-bottom: 25px;
        font-family: "oswald-regular", sans-serif;
        font-size: 14px;
        &.noBorder {
            border-right: none;
        }
        .detailShade {
            .dark & {
                color: #e8e8e8;
            }
            .titleShade {
                margin: 5px 0;
            }
            .refShade {
                margin: 0;
            }
        }
        .bgColor {
            height: 20px;
            border: 1px solid #ccc;
            border-top: none;
        }
    }
    &-figure {
        border: 1px solid #ccc;
        /*border-bottom: 20px solid;*/
        .dark & {
            background: white;
        }
        img {
            max-height: 200px;
            max-width: 100%;
            &:hover {
                opacity: 0.5;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// listShades.vue?d069f356